const cachedNOKFormatters: Record<string, Intl.NumberFormat> = {};

export const NOKFormatter = (price: number, language: string) => {
  const formatter = (cachedNOKFormatters[language] ??= new Intl.NumberFormat(language, {
    style: 'currency',
    currency: 'NOK',
  }));

  const parts = formatter.formatToParts(price);

  const isInteger = Number.isInteger(price);
  const string = parts
    .reduce((acc, part) => {
      if (part.type === 'currency') return acc; //Use our own currency symbol
      if (isInteger && (part.type === 'decimal' || part.type === 'fraction')) return acc; //Remove decimal parts if price is integer

      acc += part.value;
      return acc;
    }, '')
    .trim();

  return `${string} kr`;
};
